import { render, staticRenderFns } from "./PoGreentex.vue?vue&type=template&id=ba3828e2&scoped=true"
import script from "./PoGreentex.vue?vue&type=script&lang=js"
export * from "./PoGreentex.vue?vue&type=script&lang=js"
import style0 from "./../../../../../public/css/tailwind1.css?vue&type=style&index=0&id=ba3828e2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3828e2",
  null
  
)

export default component.exports